import {Button, Divider, Form, Row, Spin, Typography} from "antd";
import {PrintColorWhiteSVG} from "assets";
import {InputFields, ModalCustom, Notification} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import {columns, fields as fieldsInt} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import {FORMAT_TIME, LOAI_FORM, tabKeys} from "types/enums";
import {
  getDetailProposeShopping,
  getListDongNganSach,
  getListDuAn,
  getListNguonThanhToan,
  getListNhaCungCap,
  setDetailShopping,
  setTypeFormShopping,
} from "redux/reducer/proposeShopping";
import {
  convertDateStringToDateTimezone_7,
  formatDateToString,
  formatToCurrencyTypeToFixed,
  isValuable,
  randomId,
  toArray,
  toNumber,
} from "helper/common";
import {shoppingService} from "api";
import ModalSend from "./ModalSend/ModalSend";
import ModalApprove from "./ModalApprove/ModalApprove";
import ModalDeny from "./ModalDeny/ModalDeny";
import {TRANG_THAI_MUA_SAM} from "types/enums/shopping";
import ReceiptModal from "../ReceiptModal/ReceiptModal";
const DetailProposeShopping = () => {
  const dispatch = useAppDispatch();
  const [tongTien, setTongTien] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [form] = Form.useForm();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const {
    idProposeShopping,
    typeFormShopping,
    detailProposeShopping,
    listNhaCungCap,
  } = useAppSelector(state => state.proposeShopping);
  const [fields, setFields] = useState(fieldsInt);
  const modalSendRef = useRef(null);
  const modalApproveRef = useRef(null);
  const modalDenyRef = useRef(null);
  const modalPrintRef = useRef(null);

  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_SHOPPING.DETAIL) {
      dispatch(getListNhaCungCap({page: 1, limit: 50}));
      dispatch(getListDongNganSach());
      dispatch(getListNguonThanhToan());
      dispatch(getListDuAn());
    }
  }, [activeTab]);
  useEffect(() => {
    const setOptionsNhaCungCap = listNhaCungCap => {
      fields.find(e => e?.name == "nhaCungCap").options = listNhaCungCap?.map(
        e => ({
          label: e?.name,
          value: e?.name,
          key: randomId(),
        })
      );
      setFields([...fields]);
    };
    setOptionsNhaCungCap(listNhaCungCap);
  }, [listNhaCungCap]);

  useEffect(() => {
    if (isValuable(idProposeShopping)) {
      dispatch(getDetailProposeShopping(idProposeShopping));
    } else {
      dispatch(setDetailShopping(null));
    }
  }, [idProposeShopping]);
  useEffect(() => {
    console.log(typeFormShopping);
  }, [typeFormShopping]);
  useEffect(() => {
    const _setTypeFormShopping = detailProposeShopping => {
      console.log(detailProposeShopping);
      if (detailProposeShopping) {
        dispatch(setTypeFormShopping(LOAI_FORM.DA_TAO));
      } else {
        dispatch(setTypeFormShopping(LOAI_FORM.TAO_MOI));
      }
    };
    _setTypeFormShopping(detailProposeShopping);
  }, [detailProposeShopping]);
  useEffect(() => {
    const showFields = detailProposeShopping => {
      fields.find(e => e?.name == "lyDoTuChoi").hide =
        !detailProposeShopping?.lyDoTuChoi;
    };
    showFields(detailProposeShopping);
  }, [detailProposeShopping]);
  useEffect(() => {
    console.log(detailProposeShopping);
    const setFormValues = detailProposeShopping => {
      if (!detailProposeShopping) {
        form.resetFields();
        form.setFieldValue("chiTietPhieuDeNghiMuaSamDtos", []);
        form.setFieldValue("trangThaiStr", "Đang tạo đề nghị");
        setDataTable([]);
      }
      const formatData = {
        ...detailProposeShopping,
        timeLine: convertDateStringToDateTimezone_7(
          detailProposeShopping?.timeLine
        ),
        trangThai: detailProposeShopping?.trangThai ?? 0,
      };
      form.setFieldsValue(formatData);
      setDataTable(
        toArray(detailProposeShopping?.chiTietPhieuDeNghiMuaSamDtos).map(e => ({
          ...e,
          key: randomId(),
        }))
      );
    };
    setFormValues(detailProposeShopping);
    _setTongTien();
  }, [detailProposeShopping]);
  const _setTongTien = () => {
    let _tongTien: any = 0;
    form?.getFieldValue("chiTietPhieuDeNghiMuaSamDtos")?.forEach(e => {
      _tongTien += toNumber(e?.thanhTien);
    });
    setTongTien(_tongTien);
  };
  const saveBtn = () => {
    return (
      <Button
        type="primary"
        onClick={() => {
          submit();
        }}
      >
        Lưu lại
      </Button>
    );
  };

  const sendBtn = () => {
    return (
      <>
        {(detailProposeShopping?.trangThai == TRANG_THAI_MUA_SAM.NHAP ||
          !detailProposeShopping?.trangThai) && (
          <Button
            type="primary"
            onClick={() => {
              modalSendRef?.current?.openModal();
            }}
          >
            Gửi
          </Button>
        )}
      </>
    );
  };
  const approveBtn = () => {
    return (
      <>
        {(detailProposeShopping?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET ||
          detailProposeShopping?.trangThai ==
            TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
          detailProposeShopping?.trangThai ==
            TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
          <Button
            type="primary"
            onClick={() => {
              modalApproveRef?.current?.openModal();
            }}
          >
            Phê duyệt
          </Button>
        )}
      </>
    );
  };
  const denyBtn = () => {
    return (
      <>
        {(detailProposeShopping?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET ||
          detailProposeShopping?.trangThai ==
            TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
          detailProposeShopping?.trangThai ==
            TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
          <Button
            danger
            type="primary"
            onClick={() => {
              modalDenyRef?.current?.openModal();
            }}
          >
            Từ chối
          </Button>
        )}
      </>
    );
  };
  const saveAndPrintBtn = () => {
    return (
      <Button
        icon={<PrintColorWhiteSVG />}
        className="btn-sub"
        onClick={() => {
          submit();
          modalPrintRef?.current?.openModal();
        }}
      >
        Lưu và in
      </Button>
    );
  };

  const submit = async (values = null, notification = "Đã lưu thành công") => {
    try {
      const formValues = await getFormValues();

      if (!formValues) {
        return;
      }
      let data = {
        ...detailProposeShopping,
        ...formValues,
        ...values,
        timeLine: formatDateToString(
          formValues?.timeLine,
          FORMAT_TIME.invertDayFull
        ),
        trangThai: values?.trangThai ?? detailProposeShopping?.trangThai ?? 0,
        tongTien: tongTien,
      };
      setIsLoading(true);
      console.log(typeFormShopping);
      const callApi =
        typeFormShopping == LOAI_FORM.DA_TAO
          ? shoppingService.updateProposeShopping
          : shoppingService.createProposeShopping;
      const res = await callApi(data, detailProposeShopping?.id);

      dispatch(setDetailShopping(res));
      setIsLoading(false);
      console.log(notification);
      Notification("success", notification);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };

  const getFormValues = async () => {
    try {
      const formValues = await form.validateFields();
      return formValues;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_SHOPPING.DETAIL) {
      dispatch(
        setButtonsHeader([
          saveAndPrintBtn(),
          saveBtn(),
          sendBtn(),
          approveBtn(),
          denyBtn(),
        ])
      );
    } else {
      dispatch(setButtonsHeader([]));
    }
  }, [activeTab, detailProposeShopping, typeFormShopping]);

  return (
    <Spin spinning={isLoading}>
      <Form form={form}>
        <div className="container">
          <Typography.Text strong>Thông tin chung</Typography.Text>

          <Row gutter={[8, 8]}>
            <InputFields data={fields}></InputFields>
          </Row>
        </div>
        <div className="container">
          <Typography.Text strong>Chi phí dự kiến</Typography.Text>
          <TableInputAdd
            data={dataTable}
            setData={setDataTable}
            column={columns}
            name="chiTietPhieuDeNghiMuaSamDtos"
            form={form}
            isPagination={false}
            setTongTien={_setTongTien}
            scroll={{x: 600}}
          ></TableInputAdd>
          <Divider>
            <Row justify={"end"}>
              <Typography.Text strong>
                Total Cost (VNĐ): {formatToCurrencyTypeToFixed(tongTien, 4)}
              </Typography.Text>
            </Row>
          </Divider>
        </div>

        <ModalCustom
          ref={modalSendRef}
          width={600}
          title="Gửi yêu cầu phê duyệt"
        >
          <ModalSend submit={submit} isLoading={isLoading}></ModalSend>
        </ModalCustom>
        <ModalCustom
          ref={modalApproveRef}
          width={600}
          title="Phê duyệt yêu cầu"
        >
          <ModalApprove submit={submit} isLoading={isLoading}></ModalApprove>
        </ModalCustom>
        <ModalCustom ref={modalDenyRef} width={600} title="Từ chối yêu cầu">
          <ModalDeny submit={submit} isLoading={isLoading}></ModalDeny>
        </ModalCustom>
        <ModalCustom
          title="Phiếu đề nghị mua sắm"
          isLoading={isLoading}
          ref={modalPrintRef}
          width={1000}
        >
          <ReceiptModal></ReceiptModal>
        </ModalCustom>
      </Form>
    </Spin>
  );
};
export default DetailProposeShopping;
